/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ImportIntoCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['fromCourseId', codecNumber, 'from_course_id'],
]);
export class ImportIntoCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ImportIntoCourseDataParser.decode(input).map(res => new ImportIntoCourseData(res));
    }
    static unsafeDecode(input) {
        return ImportIntoCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ImportIntoCourseDataParser.encode(data);
    }
    static schema() {
        return ImportIntoCourseDataParser.schema();
    }
}
